import { createFileRoute } from "@tanstack/react-router";
import DepressionWithoutMedicationPage from "@/pages/learn/DepressionWithoutMedicationPage";
import { page7 } from "@/pages/learn/learnDataP7";
export const Route = createFileRoute(
  "/learn/depression-treatment-without-medication",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Without Medication: What Works",
        },
        {
          name: "description",
          content:
            "Evidence-based non-medication treatments for depression: therapy, exercise, light therapy, supplements, and FDA-cleared TMS and SAINT, with risks explained.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Without Medication: What Works",
        },
        {
          property: "og:description",
          content:
            "Evidence-based non-medication treatments for depression: therapy, exercise, light therapy, supplements, and FDA-cleared TMS and SAINT, with risks explained.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/depression-treatment-without-medication",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/depression-treatment-without-medication",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page7.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionWithoutMedicationPage />;
}
